import * as React from 'react';
import { fetchCountry, createListTypeAndSort } from '@gandi/redux-places';
import { useTranslator } from '@gandi/translate';
import { SelectField } from 'gandi.react-form';
import useCountry from '../hooks/useCountry';
import { jsx as _jsx } from "react/jsx-runtime";
function SubdivisionField({
  bu,
  country,
  ...inputProps
}) {
  const {
    __
  } = useTranslator();
  const {
    subdivisionsByType
  } = useCountry(country, bu);
  const options = createListTypeAndSort(subdivisionsByType);
  return /*#__PURE__*/_jsx(SelectField, {
    help: __('Please indicate your state or region.'),
    label: __('States'),
    name: "state",
    placeholder: __('Select an item...'),
    values: options,
    variant: ['block'],
    ...inputProps
  });
}
SubdivisionField.preFetch = function preFetch({
  country,
  bu,
  dispatch
}) {
  if (country) {
    return dispatch(fetchCountry(country, bu));
  }
  return Promise.resolve();
};
export default SubdivisionField;